import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
export var RippleEffectBase = function (props) {
    var sourceBackgroundColor = props.sourceBackgroundColor;
    return (React.createElement(RampWithNameTransform, { rampName: "Container" },
        React.createElement(RampWithNameTransform, { rampName: "Content", sourceBackgroundColor: sourceBackgroundColor })));
};
